import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "../../../../Assets/Scss/NewsLetter.scss";
import { postNewsletteraction, resetNewsletterStateAction } from "../../../../Store/NewsLetter/action";
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Newsletter(){const { successMessage, loading, sucess, errorMessage } = useSelector(
  (state) => state.Newsletter
);

const dispatch = useDispatch();

const [email_id, setEmail] = useState("");

const validate = (email) => {
var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
return re.test(email);
}

const handleNewsletter = () => {
  if(!(validate(email_id))){
  toast.error("Please provide a valid email address.")
  return;
}
  dispatch(postNewsletteraction({ email_id }));
};

React.useEffect(()=>{
 if(sucess){
    toast.success(successMessage);
  dispatch(resetNewsletterStateAction());
  }

  if(errorMessage){
    toast.error(errorMessage);
  dispatch(resetNewsletterStateAction());
  }

},[dispatch, errorMessage, loading, successMessage, sucess])

    return(
       <>
       <div className="subscribe-i4">
         <h2 className="subscribe-i4__title">Let's keep in touch</h2>
         <p className="subscribe-i4__copy">
           Subscribe to keep up with fresh deals and exciting offers. We promise not to
           spam you!
         </p>
         <div className="form-i4">
           <input
            value={email_id}
            onChange={(e) => setEmail(e.target.value)}
             type="email"
             className="form-i4__email"
             placeholder="Enter your email address"
             style={{outline:"none"}}
           />
           <button className="form-i4__button" 
            onClick={() => handleNewsletter()}>SUBSCRIBE</button>
         </div>
         <div className="notice">
           <span className="notice__copy">
             We will never share your email with a third party.
           </span>
         </div>
       </div>
       <br />
       </> 
    )
}
